export default [
  { title: "Request Transfer", icon: "ri-wallet-", link: "/request-transfer" },
  { title: "Invoice", icon: "ri-wallet-", link: "/invoice" },
  { title: "Incoming Transfer", icon: "ri-wallet-", link: "/incoming-transfer" },
];
